<template>
	<div class="jobsapply">
		<b-container class="container-lg mt-top text-left prl-outside">
			<b-row class="mb-3 top-text">{{$t('title')}}</b-row>
			<p class="mb-5 text-left">
				{{$t('titleText')}}
			</p>
			<b-form inline enctype="multipart/form-data" @submit="sendApply" @reset="onReset" class="prl-inside">
				<b-row class="prl-inside">
					<p>{{$t('text1')}}</p>
					<b-form-input id="firstname" name="firstname" size="sm" v-model="form.firstname" required :placeholder="$t('firstname')" class="inp-30"></b-form-input>
					<b-form-input id="lastname" name="lastname" size="sm" v-model="form.lastname" required :placeholder="$t('lastname')" class="inp-middle-30"></b-form-input>
					<b-form-datepicker id="dateofbirth" name="dateofbirth" size="sm" v-model="form.dateofbirth" required :placeholder="$t('birthDate')" class="inp-30" locale="de" v-bind="labels['de'] || {}"></b-form-datepicker>
					<b-form-input id="street" name="street" size="sm" v-model="form.street" required :placeholder="$t('street')" class="inp-30"></b-form-input>
					<b-form-input id="zip" name="zip" size="sm" v-model="form.zip" required :placeholder="$t('post')" class="inp-middle-20"></b-form-input>
					<b-form-input id="city" name="city" size="sm" v-model="form.city" required :placeholder="$t('city')" class="inp-40"></b-form-input>

					<b-form-input id="country" name="country" size="sm" v-model="form.country" required :placeholder="$t('country')" class="inp-30"></b-form-input>
					<b-form-input id="phone1" name="phone1" size="sm" v-model="form.phone1" required :placeholder="$t('phone')" class="inp-middle-30"></b-form-input>
					<b-form-input id="email" name="email" required type="email" size="sm" v-model="form.email" :placeholder="$t('email')" class="inp-30"></b-form-input>

					<b-form-input id="education" name="education" size="sm" v-model="form.education" required :placeholder="$t('education')" class="inp-30"></b-form-input>
					<b-form-input id="licence" name="licence" size="sm" v-model="form.licence" :placeholder="$t('drivers')" class="inp-middle-30"></b-form-input>
					<b-form-datepicker id="available" name="available" size="sm" v-model="form.available" :placeholder="$t('available')" class="inp-30" :locale="$i18n.locale" v-bind="labels[$i18n.locale] || {}"></b-form-datepicker>

					<b-form-textarea id="message" name="message" size="sm" rows="6" max-rows="6" v-model="form.message" :placeholder="$t('message')" class="mb-3 w-100"></b-form-textarea>
				
					<p>{{$t('addPhoto')}}</p>

					<b-form-file v-show="!form.userpic && !url"
						class="w-100 p-0 m-0"
						name="userpic"
						size="sm"
						v-model="form.userpic"
						accept=".png, .jpg, .jpeg"
						:placeholder="$t('selectPhoto')"
						@change="onFileChange"
					></b-form-file>

					<div v-if="url" style="width:110px;height:110px;position:relative;overflow:hidden;" @click="removePicture()">
						<img :src="url" class="w-100">
						<div class="remove-picture remove-overlay"><i class="fas fa-times fa-6x"></i></div>
					</div>

					<p class="mt-3 mb-3 pt-2" style="border-top: solid 1px black">{{$t('addFiles')}}</p>
					<div v-if="att.length>0" style="width:100%;height:auto;" >
						<div v-for="(pic, key) in att" :key="key" class="mb-1 mr-1" style="float:left;width:110px;height:110px;position:relative;overflow:hidden;" @click="removeAttachment(key)" :title="pic.name">
							<img :src="getPicture(pic)" class="w-100">
							<div class="remove-picture remove-overlay"><i class="fas fa-times fa-6x"></i></div>
						</div>
					</div>
					<b-form-file
						class="mb-3"
						id="files"
						name="files"
						size="sm"
						v-model="form.attachments"
						multiple
						accept=".png, .jpg, .jpeg, .doc, .docx, .pdf"
						:placeholder="$t('selectFile')"
						@change="onAttachmentChange"
					></b-form-file>
					
					<b-form-checkbox
						id="evidenz"
						v-model="form.evidenz"
						name="evidenz"
						value="true"
						unchecked-value="false"
						class="mb-4 mt-4"
					>
						{{$t('agreement')}}
					</b-form-checkbox> 
					<vue-recaptcha
						:sitekey="$store.state.siteKey"
						ref="recaptcha"
						@verify="onCaptchaVerified"
						@expired="onCaptchaExpired"
						size="invisible"
					></vue-recaptcha>
					<b-button v-if="!uploading" class="gera-btn" variant="primary" type="submit">{{$t('send')}}</b-button>
					<b-button v-else class="gera-btn" style="width:300px;background-color: white !important;"><b-spinner variant="primary"></b-spinner></b-button>
					<p class="mt-2 fs07 text-center">{{$t('reCaptcha')}}<br>
					<a href="https://policies.google.com/privacy">{{$t('pp')}}</a> {{$t('and')}}
					<a href="https://policies.google.com/terms">{{$t('ts')}}</a>{{$t('apply')}}</p>
				</b-row>
			</b-form>
		</b-container>
		<div class="big-text text-left">{{$t('jobs')}}</div>
		<app-modal width="350px" @closeModal="showMessage=false" v-show="showMessage">
			<div slot="title">
				<div class="float-left" :style="messageColor"><i class="fas fa-exclamation-circle fa-2x" :style="messageColor"></i></div><div class="float-left ml-2 modal-header-text" :style="messageColor">{{message}}</div>
			</div>
			<div slot="content" class="text-left bb-gera"></div>
			<div slot="buttons-right">
				<b-button class="btn-confirm" size="sm" @click="showMessage=false">OK</b-button>
			</div>
		</app-modal>
	</div>
</template>

<script>
import api from '@/components/backend-api'
import appModal from '@/components/Modal.vue'
import VueRecaptcha from 'vue-recaptcha'

import imgPDF from '@/assets/img/fu_pdf.png'
import imgWord from '@/assets/img/fu_word.png'
import ImgExcel from '@/assets/img/fu_excel.png'
export default {
	name: 'JobsApply',
	components: {
		appModal,
		VueRecaptcha
	},
	data () {
		return {
			status: '',
			sucessfulServerResponse: '',
			serverError: '',
			showMessage: false,
			message: '',
			messageColor: 'color:#307bad',
			url: null,
			att: [],
			uploading: false,
			selectedFile: null,
			form: {
				firstname: '',
				lastname: '',
				dateofbirth: '',
				street: '',
				zip: '',
				city: '',
				country: '',
				phone1: '',
				email: '',
				education: '',
				licence: '',
				available: '',
				message: '',
				status: '',
				evidenz: false,
				userpic: null,
				attachments: []
			},
			labels: {
				de: {
					labelPrevDecade: 'Vorheriges Jahrzehnt',
					labelPrevYear: 'Vorheriges Jahr',
					labelPrevMonth: 'Vorheriger Monat',
					labelCurrentMonth: 'Aktueller Monat',
					labelNextMonth: 'Nächster Monat',
					labelNextYear: 'Nächstes Jahr',
					labelNextDecade: 'Nächstes Jahrzehnt',
					labelToday: 'Heute',
					labelSelected: 'Ausgewähltes Datum',
					labelNoDateSelected: 'Kein Datum ausgewählt',
					labelCalendar: 'Kalender',
					labelNav: 'Kalendernavigation',
					labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren'
				}
			}
		}
	},
	methods: {
		onCaptchaVerified (recaptchaToken) {
			this.$refs.recaptcha.reset();

			var formElement = document.querySelector('form');
			const fd = new FormData(formElement);
			if (!fd.evidenz) {
				fd.append ('evidenz', 'false');
			}

			fd.append('recaptchaToken', recaptchaToken);
			this.uploading = true;
			let modal = this.$store.state.modal;
			api.executePostServerAction('/redakteur/sendJobhunting', fd, false, true)
				.then(response => {
					// console.log('Response:');
					// console.log(response);
					this.uploading = false;
					if (response.status == 200){
						modal.message = this.$t('thanks'); // + response.data.message;
						modal.color = 'color:#307bad !important';
						modal.type = 'warning';
						modal.show = true;

						// this.message=response.data.message;
						// this.messageColor='color:#307bad !important';
						// this.showMessage=true;

						this.form.firstname = '';
						this.form.lastname = '';
						this.form.dateofbirth = '';
						this.form.street = '';
						this.form.zip = '';
						this.form.city = '';
						this.form.country = '';
						this.form.phone1 = '';
						this.form.email = '';
						this.form.education = '';
						this.form.licence = '';
						this.form.available = '';
						this.form.message = '';
						this.form.status = '';
						this.form.evidenz = false;
						this.form.userpic = null;
						this.form.attachments = [];
						this.form.attachments.length = 0;
					} else {
						modal.message = response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
						// this.message=response.data.message;
						// this.messageColor='color:darkred !important';
						// this.showMessage=true;
					}
				})
				.catch(error => {
					console.log('Send contact error!');
					// console.log('Error: ' + error);
					// console.log(error.response);
					this.uploading = false;

					if (error !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:#307bad !important';
						modal.type = 'warning';
						modal.show = true;
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}

					// this.messageColor='color:darkred !important';
					// this.message='Fehler! '+error.response.data.message;
					// this.showMessage=true;
				})
		},
		onCaptchaExpired () {
			this.$refs.recaptcha.reset();
		},
		getPicture (pic) {
			switch(pic.type) {
				case 'jpg','png', 'jpeg':
					return pic.data
					break;
				case 'pdf':
					return imgPDF
					break;
				case 'doc':
					return imgWord
					break;
				case 'docx':
					return imgWord
					break;
				case 'xls':
					return imgExcel
					break;
				case 'xslx':
					return imgExcel
					break;
			}
		},
		removeAttachment (index) {
			this.form.attachments.splice(index,1);
			this.att.splice(index,1);
		},
		removeFoto () {
			this.form.userpic = null;
		},
		sendApply (evt) {
			evt.preventDefault();
			this.$refs.recaptcha.execute();
		},
		onReset () {

		},
		onFileChange (e) {
//			console.log('FILE CHANGE!')
			const file = e.target.files[0];
			this.url = URL.createObjectURL(file);
		},
		onAttachmentChange (e) {
//			console.log('ATTACHMENT FILES CHANGE!')
			this.att = [];
			this.att.length = 0;
//			console.log(e)
//			console.log(e.target)
//			console.log(e.target.files)
			e.target.files.forEach(element => {
				let fileExt = element.name.split('.').pop();
//				console.log(element.name);
				this.att.push({ name: element.name, type: fileExt, data: URL.createObjectURL(element) });
			});
		},
		removePicture () {
			if (this.url){
				this.url = null;
				this.form.userpic = null;
				return false
			} 
			if (this.form.userpic) {
				this.form.userpic = null;
			}
		},
	}
}
</script>
<style>
	.custom-file-input {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
</style>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
	}
	.inp-30 { width:31.5% !important; margin-bottom:20px; }
	.inp-40 { width:46.5% !important; margin-bottom:20px; }
	.inp-middle-20 { width:16% !important; margin: 0 3% 20px; }
	.inp-middle-30 { width:31% !important; margin: 0 3% 20px; }
	.remove-overlay {
		top:0;
		left:0;
		width:100% !important;
		padding-left:15px !important;
		padding-top:0px !important;
	}
	@media only screen and (max-width: 992px) {
		.inp-30 { width:100% !important;; margin-bottom:20px; }
		.inp-middle-30, .inp-middle-20 { width:100% !important;; margin: 0 0 20px; }
		.inp-40 { width: 75% !important;;  margin-bottom:20px; }
		.inp-middle-20 { width:22% !important; margin: 0 3% 20px 0; }
	}
</style>
<i18n>
	{
		"de": {
			"title": "Einfach online bewerben!",
			"titleText": "Möchtest auch du Teil eines starken, dynamischen Teams werden und dank unseres Know-hows auf der ganzen Welt oder aber auch besonders lokal arbeiten und deinen Traumberuf ausüben, dann freuen wir uns auf deine Bewerbung.",
			"text1": "Mit * gekennzeichnete Felder sind Pflichtfelder",
			"firstname": "Vorname*",
			"lastname": "Nachname*",
			"birthDate": "Geburtsdatum*",
			"street": "Straße, Hausnummer*",
			"post": "PLZ*",
			"city": "Ort*",
			"country": "Land*",
			"phone": "Telefonnummer*",
			"email": "E-mail*",
			"education": "Ausbildung*",
			"drivers": "Führerschein Klassen",
			"available": "Verfugbar ab...",
			"message": "Nachricht",
			"addPhoto": "Bitte ergänzen Sie Ihre Bewerbung mit einem Portraitfoto.",
			"selectPhoto": "Foto auswahlen...",
			"addFiles": "Übermitteln Sie uns bitte zusätzliche Dateien wie Lebenslauf, Zeugnisse, Bewerbungsschreiben etc.",
			"selectFile": "Datei auswahlen...",
			"agreement": "Ich willige ein, dass meine personbezogenen Daten und Beewerbungsunterlagen auch im Falle einer Absage weiterhin in Evidenz gehalten werden und für zukünftige Bewerbungsverfahren herangezogen werden dürfen. Diese Einwilligung kann ich jederzeit wiederrufen. Details hierzu finde ich inder Datenschutzerklärung. ",
			"send": "Abschicken",
			"thanks": "Wir danken für Ihre Nachricht und werden uns rasch um Ihr Anliegen bemühen.",
			"reCaptcha": "Diese Website ist durch reCAPTCHA geschützt und es gelten",
			"pp": "die Google-Datenschutzbestimmungen",
			"and": "und",
			"ts": "Nutzungsbedingungen",
			"apply": ".",
			"jobs": "Jobs"
		},
		"en": {
			"title": "Apply easily online!",
			"titleText": "We are looking forward to your application if you would like to become part of a strong, dynamic team, would like to work throughout the world because of our expertise or if you would especially like to work locally and would like to work at your dream job.",
			"text1": "Fields marked with an * are mandatory",
			"firstname": "First name*",
			"lastname": "Last name*",
			"birthDate": "Date of birth*",
			"street": "Street, house number*",
			"post": "Postcode*",
			"city": "City*",
			"country": "Country*",
			"phone": "Phone number*",
			"email": "E-mail*",
			"education": "Education*",
			"drivers": "Driver's licence",
			"available": "Available as of...",
			"message": "Message",
			"addPhoto": "Please add a portrait photo to your application.",
			"selectPhoto": "Select photo...",
			"addFiles": "Please send us additional files such as curriculum vitae, certificates, cover letters, etc.",
			"selectFile": "Select file...",
			"agreement": "I agree that my personal data and application documents will continue to be kept in evidence even in the event of a rejection and may be used for future application processes. I can revoke this consent at any time. I can find details on this in the privacy policy.",
			"send": "Send",
			"thanks": "We would like to thank you for your message and will answer your request as soon as possible.",
			"reCaptcha": "This site is protected by reCAPTCHA and the Google",
			"pp": "Privacy Policy",
			"and": "and",
			"ts": "Terms of Service",
			"apply": "apply.",
			"jobs": "Jobs"
		}
	}
</i18n>
